import { useParams } from 'react-router-dom';
import { fetchPosts } from '../../utils/blogUtils';
import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import './Blog.css'
import { PostHead, PostNav, PostFooter, PostSlider } from "../../components/blog";

const BlogMarkdownViewer = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [postsNav, setPostsNav] = useState([]);
  const [postList, setPostList] = useState(null);

  useEffect(() => {
    fetchPosts().then((posts) => {
      const listFiltered = posts.filter((post) => posts.length <= 1 || post.slug !== slug);

      setPost(posts.find((post) => post.slug === slug) || null);
      setPostsNav(listFiltered.map(({ slug, title }) => ({ slug, title })));
      setPostList(listFiltered)

      setLoading(false);

    })
  }, [slug]);

  if (loading) return <div>Cargando post...</div>;
  if (!post) return <div>Post no encontrado.</div>;

  return (
    <section id="post" className='post container mx-auto w-100 py-5'>
      <PostNav posts={postsNav} />
      <div className='container px-lg-5'>
        <PostHead publisher={post.publisher} publicationDate={post.formattedCreated} readingTime={post.readTime} />
        <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]} components={{
          img: ({ alt, src, title }) => (
            <img alt={alt} src={src} title={title} className='img-fluid my-3' />
          ),
          p: ({ node, children }) => {
            // Detectar si solo hay una imagen dentro
            if (
              node.children.length === 1 &&
              node.children[0].tagName === 'img'
            ) {
              return <>{children}</>;
            }
            return <p>{children}</p>;
          }
        }} >
          {post.content}
        </ReactMarkdown>
        <PostFooter slug={postsNav[0].slug} title={postsNav[0].title} />
        <PostSlider posts={postList} />
      </div>
    </section>
  );
};

export default BlogMarkdownViewer;